import DevicesContainer from "./DevicesContainer";

export default DevicesContainer;
